<template>
  <el-dialog
    title="個人訂閱"
    fullscreen
    @close="handleDlgClose"
    :visible.sync="innerVisible"
  >
    <div class="container" v-loading="isLoading">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-width="100px"
            :inline="true"
            @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
          >
            <el-form-item label="關鍵字">
              <el-input
                v-model="queryForm.qstr"
                size="small"
                placeholder="編號、班名、名稱、序號、備註"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                @click="handleQueryClick(queryForm)"
                size="small"
                >查詢</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-button
            type="primary"
            @click="handleBatchSubs"
            size="small"
            :disabled="selectedRow.length === 0"
            >批次訂閱</el-button
          >

          <el-button
            type="danger"
            @click="handleBatchUnsubs"
            size="small"
            :disabled="selectedRow.length === 0"
            >批次退訂</el-button
          >
        </div>
      </div>
    </div>

    <CCard>
      <CCardHeader>
        <CIcon name="cil-library-building" /> 訂閱頻道：{{ channelName }}
      </CCardHeader>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            v-loading="isLoading"
            ref="dataTable"
            :data="members"
            @sort-change="sortChange"
            :default-sort="{ prop: defaultSortCol, order: defaultOrder }"
            @selection-change="handleSelectionChange"
            stripe
            style="width: 100%"
          >
            <el-table-column type="selection" width="45"> </el-table-column>

            <el-table-column
              prop="id"
              type="index"
              :index="indexFormatter"
              fixed
            >
            </el-table-column>

            <el-table-column
              label="人員編號"
              prop="member.no"
              sortable="custom"
              width="100"
            >
            </el-table-column>

            <el-table-column
              label="人員名稱"
              prop="member.name"
              sortable="custom"
              width="100"
            >
            </el-table-column>

            <el-table-column
              label="班級名稱"
              prop="member.className"
              sortable="custom"
              width="120"
            >
            </el-table-column>

            <el-table-column
              label="月光機序號"
              prop="member.moonlight2SerialNumber"
              sortable="custom"
              width="200"
            >
            </el-table-column>

            <el-table-column label="備註" prop="member.memo" width="140">
            </el-table-column>
          </el-table>
        </CRow>

        <CRow>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </CRow>

        <SubsOptionsDlg
          v-model="isDlgVisible"
          :key="dlgKey"
          @startSubs="handleStartBatchSubs"
        ></SubsOptionsDlg>
      </CCardBody>
    </CCard>

    <template #footer class="dialog-footer">
      <el-button @click="innerVisible = false">關閉</el-button>
    </template>
  </el-dialog>
</template>

<script>
import API from "@/api/";
import moment from "moment-timezone";
import { mapGetters } from "vuex";
import { MAX_DUEDATE, NO_DATE } from "../../appConfig";
import SubsOptionsDlg from "./SubsOptionsDlg";
export default {
  components: {
    SubsOptionsDlg,
  },
  model: {
    prop: "visible",
    event: "toggleVisible",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    deptId: {
      type: Number,
      default: null,
    },
    deptName: {
      type: String,
    },
    channelId: {
      type: Number,
    },
    channelName: {
      type: String,
    },
    assets: {
      type: Array,
    },
    assetName: {
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      myownOrg: "auth/orgName",
      members: "deptMember/deptMembers",
      total: "deptMember/total",
      offset: "deptMember/offset",
      sort: "deptMember/sort",
      order: "deptMember/order",
    }),
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },
  data() {
    return {
      defaultSortCol: "member.name",
      defaultOrder: "ascending",
      isDlgVisible: false,
      dlgKey: 0,
      isLoading: false,
      disabledSwitchIdx: [],
      formLabelWidth: "100px",
      pageSize: 50,
      currentPage: 1,
      selectedRow: [],
      queryForm: {
        qstr: "",
      },
      activeQueryForm: {
        qstr: "",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > MAX_DUEDATE;
        },
        shortcuts: [
          {
            text: "不限制",
            onClick(picker) {
              const date = NO_DATE;
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周後",
            onClick(picker) {
              const m = moment()
                .startOf("day")
                .add(1, "weeks")
                .valueOf();
              const date = new Date(m);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一個月後",
            onClick(picker) {
              const m = moment()
                .startOf("day")
                .add(1, "months")
                .valueOf();
              const date = new Date(m);
              picker.$emit("pick", date);
            },
          },
          {
            text: "三個月後",
            onClick(picker) {
              const m = moment()
                .startOf("day")
                .add(3, "months")
                .valueOf();
              const date = new Date(m);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一年後",
            onClick(picker) {
              const m = moment()
                .startOf("day")
                .add(1, "years")
                .valueOf();
              const date = new Date(m);
              picker.$emit("pick", date);
            },
          },
        ],
      },
    };
  },
  created() {
    this.$store.commit("deptMember/CLEAR");
    this.$store.commit("deptMember/SET_SORT", this.defaultSortCol);
    this.$store.commit("deptMember/SET_ORDER", this.defaultOrder);
    if (this.innerVisible) {
      //NOTE: always start from the first page
      this.query(this.pageSize, 0, this.sort, this.order);
    }
  },
  methods: {
    isBlueLight(row) {
      const endDate = row.subscriptions[0].endDate;
      return endDate === NO_DATE;
    },
    isRedLight(row) {
      return row.subscriptions[0].endDate < Date.now();
    },
    isSwitchDisabled(idx) {
      return this.disabledSwitchIdx.includes(idx);
    },

   batchHandler(options, action, successMsg) {
      const { isNeedApprove, hasEndDate, endDate } = options;
      const effEndDate = hasEndDate ? endDate : NO_DATE;
      this.isLoading = true;
      const params = {};
      params.deptMemberIds = this.selectedRow.map((it) => it.id);
      params.groupIds=[];
      params.channelId = this.channelId;
      params.assetIds = this.assets.map((it) => it.id);
      params.isNeedApprove = isNeedApprove;
      params.endDate = effEndDate;
      params.action = action;
      API.subscribe.batchSubs(params).then(() => {
        this.$message.success(successMsg);
      }).finally(()=>{
        this.isLoading = false;
      });
    },

    handleBatchSubs() {
      this.isDlgVisible = true;
      this.dlgKey = this.dlgKey ? 0 : 1;
    },

    handleStartBatchSubs(options) {
      this.batchHandler(options, "subscribe", "批次訂閱成功");
    },

    handleBatchUnsubs() {
      this.batchHandler(
        { isNeedApprove: false, hasEndDate: false, endDate: NO_DATE },
        "unsubscribe",
        "批次退訂成功"
      );
    },

    handleSelectionChange(rows) {
      //console.log(`handleSelectionChange: val = ${JSON.stringify(rows)}`);
      this.selectedRow = rows;
    },

    changeSubscription(isSubscr, mbr, index) {
      const isChecked = this.selectedRow.find(
        row => row.member.name === mbr.member.name
      );
      let p;
      this.disabledSwitchIdx.push(index);
      if (isSubscr) {
        p = this.subsAsset(mbr, index);
      } else {
        p = this.unsubsAsset(mbr, index);
      }
      p.finally(() => {
        isChecked &&
          this.$refs.dataTable.toggleRowSelection(this.members[index], true);

        const found = this.disabledSwitchIdx.indexOf(index);
        found !== -1 && this.disabledSwitchIdx.splice(found, 1);
      });
    },

    subsAsset(
      mbr,
      index,
      updateStore = true,
      showMsg = true,
      needAppr = false,
      endDate = NO_DATE,
    ) {
      const params = {};
      params.deptMemberId = mbr.id;
      params.channelId = this.channelId;
      params.assetIds = this.assets.map(it=>it.id);
      params.isNeedApprove = needAppr;
      params.endDate = endDate;
      return API.subscribe.addSubs(params).then(res => {
        if (updateStore) {
          const newMbr = { ...mbr };
          const subs = [
            {
              id: res.data.id,
              isNeedApprove: needAppr,
              endDate: endDate === NO_DATE ? NO_DATE : endDate.toString(),
            },
          ];
          newMbr.subscriptions = subs;

          const payload = {};
          payload.newMbr = newMbr;
          payload.index = index;
          this.$store.commit("deptMember/CHANGE_MEMBER", payload);
        }

        showMsg &&
          this.$message({
            type: "success",
            message: "訂閱成功!",
          });
        return res;
      });
    },

    unsubsAsset(mbr, index, updateStore = true, showMsg = true) {
      return API.subscribe.removeSubs(mbr.subscriptions[0].id).then(res => {
        if (updateStore) {
          const newMbr = { ...mbr };
          newMbr.subscriptions = [];

          const payload = {};
          payload.newMbr = newMbr;
          payload.index = index;
          this.$store.commit("deptMember/CHANGE_MEMBER", payload);
        }

        showMsg &&
          this.$message({
            type: "success",
            message: "退訂成功!",
          });
        return res;
      });
    },

    isAssetSubscribed(usr) {
      return usr.subscriptions.length > 0 ? true : false;
    },

    needApprove(usr) {
      return usr.subscriptions.length > 0 && usr.subscriptions[0].isNeedApprove;
    },

    changeEndDate(newEndDate, mbr, index) {
      const effEndDate = newEndDate;
      const isChecked = this.selectedRow.find(
        row => row.member.name === mbr.member.name
      );
      let p;
      this.disabledSwitchIdx.push(index);
      p = this.setApprEndDate(effEndDate, mbr, index);
      p.finally(() => {
        isChecked &&
          this.$refs.dataTable.toggleRowSelection(this.members[index], true);

        const found = this.disabledSwitchIdx.indexOf(index);
        found !== -1 && this.disabledSwitchIdx.splice(found, 1);
      });
    },

    setApprEndDate(newEndDate, mbr, index, updateStore = true, showMsg = true, newIsNeedApprove = null) {
      const params = {};
      const effIsNeedApprove = newIsNeedApprove === null ? mbr.subscriptions[0].isNeedApprove : newIsNeedApprove;
      params.endDate = newEndDate;
      params.isNeedApprove = effIsNeedApprove;
      return API.subscribe
        .changeSubs(mbr.subscriptions[0].id, params)
        .then(res => {
          if (updateStore) {
            const newMbr = { ...mbr };
            const subscriptions = [
              {
                id: res.data.id,
                isNeedApprove: effIsNeedApprove,
                endDate: newEndDate === NO_DATE ? NO_DATE : newEndDate.toString(),
              },
            ];
            newMbr.subscriptions = subscriptions;

            const payload = {};
            payload.newMbr = newMbr;
            payload.index = index;
            this.$store.commit("deptMember/CHANGE_MEMBER", payload);
          }

          showMsg &&
            this.$message({
              type: "success",
              message: "到期日設定成功!",
            });
        });
    },

    changeApprNeed(needAppr, mbr, index) {
      const isChecked = this.selectedRow.find(
        row => row.member.name === mbr.member.name
      );
      let p;
      this.disabledSwitchIdx.push(index);
      if (needAppr) {
        p = this.setNeedAppr(true, mbr, index);
      } else {
        p = this.setNeedAppr(false, mbr, index);
      }
      p.finally(() => {
        isChecked &&
          this.$refs.dataTable.toggleRowSelection(this.members[index], true);

        const found = this.disabledSwitchIdx.indexOf(index);
        found !== -1 && this.disabledSwitchIdx.splice(found, 1);
      });
    },

    setNeedAppr(needAppr, mbr, index, updateStore = true, showMsg = true) {
      const params = {};
      params.isNeedApprove = needAppr;
      return API.subscribe
        .setApprNeed(mbr.subscriptions[0].id, params)
        .then(res => {
          if (updateStore) {
            const newMbr = { ...mbr };
            const subscriptions = [
              {
                id: res.data.id,
                isNeedApprove: needAppr,
                endDate: mbr.subscriptions[0].endDate,
              },
            ];
            newMbr.subscriptions = subscriptions;

            const payload = {};
            payload.newMbr = newMbr;
            payload.index = index;
            this.$store.commit("deptMember/CHANGE_MEMBER", payload);
          }

          showMsg &&
            this.$message({
              type: "success",
              message: "審核設定成功!",
            });
        });
    },

    handleQueryClick(queryForm) {
      this.currentPage = 1; //reset pagination to the first page
      this.activeQueryForm = { ...queryForm };
      this.query(this.pageSize, 0, this.sort, this.order, this.activeQueryForm);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.query(val, this.offset, this.sort, this.order, this.activeQueryForm);
    },
    handleCurrentChange(page) {
      this.query(
        this.pageSize,
        this.pageSize * (page - 1),
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },

    query(max, offset, sort, order, params = {}) {
      return this.$store
        .dispatch("deptMember/list", {
          max: max,
          offset: offset,
          sort,
          order,
          dept: this.deptId,
          channel: this.channelId,
          ...params,
        })
        .finally(() => {
          this.disabledSwitchIdx = [];
        });
    },
    indexFormatter(index) {
      return `#${parseInt(this.offset) + index + 1}`;
    },
    sortChange(args) {
      if (args.order === null) {
        this.$store.commit("deptMember/SET_SORT", this.defaultSortCol);
        this.$store.commit("deptMember/SET_ORDER", this.defaultOrder);
      } else {
        this.$store.commit("deptMember/SET_SORT", args.prop);
        this.$store.commit("deptMember/SET_ORDER", args.order);
      }
      this.query(
        this.pageSize,
        this.offset,
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
    handleDlgClose() {},
  },
};
</script>

<style>
.greenicon {
  width: 22px;
  height: 22px;
  margin-left: 1px;
  margin-right: 4px;
}
.redicon {
  width: 20px;
  height: 20px;
  margin-left: 2px;
  margin-right: 5px;
}
.blueicon {
  width: 20px;
  height: 20px;
  margin-left: 2px;
  margin-right: 5px;
}
</style>
